import axios from "axios";

function queryString(params = {}) {
    const query = Object.keys(params)
        .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== "")
        .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(params[key]))
        .join("&");
    return query ? "?" + query : "";
}

function downloadBlob(blob, fileName) {
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
    link.remove();
}

export function getManufacturerListFun(params) {
    return axios.get("/api/bms/manufacturer" + queryString(params)).then((res) => res.data);
}

export function saveManufacturerFun(data) {
    return data.id
        ? axios.put("/api/bms/manufacturer", data).then((res) => res.data)
        : axios.post("/api/bms/manufacturer", data).then((res) => res.data);
}

export function deleteManufacturerFun(id) {
    return axios.delete("/api/bms/manufacturer/" + id).then((res) => res.data);
}

export function exportManufacturerFun(params) {
    return axios.get("/api/bms/manufacturer/export" + queryString(params), {
        headers: { Accept: "application/octet-stream" },
        responseType: "blob",
    }).then((res) => {
        downloadBlob(res.data, "维保品牌价格.xlsx");
    });
}

export function downloadManufacturerTemplateFun() {
    return axios.get("/api/bms/manufacturer/template", {
        headers: { Accept: "application/octet-stream" },
        responseType: "blob",
    }).then((res) => {
        downloadBlob(res.data, "维保品牌价格导入模板.xlsx");
    });
}

export function importManufacturerFun(file) {
    const formData = new FormData();
    formData.append("file", file);
    return axios.post("/api/bms/manufacturer/import", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    }).then((res) => res.data);
}
